import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/content/layouts/default.vue").then(m => m.default || m)),
  editor: defineAsyncComponent(() => import("/builds/rialtic/qa/argocd-releases/console-ui/apps/content/layouts/editor.vue").then(m => m.default || m)),
  "auth-public": defineAsyncComponent(() => import("#build/layouts.public.CzFuo2xU8QmNi7iDi5d157AMp77fhphFOcEdUnowQDU.vue").then(m => m.default || m))
}